import type { Override } from "@tanstack/react-query";
import type { CaseExtended } from "@waku-care/types/contracts/internal";

import type { DeviceDetailCorrected } from "@/api/resources/devices/types";
import type { CaseDetail, CaseStatus, CaseTag, CaseToDeviceDatumTrigger, CaseToMaintenance } from "@/supabase.types";

// a case with its device and links, as returned by the backend (without the internal search columns)
export type PaginatedCase = CaseExtended;

export interface SearchCasesProps {
  query: string;
  workspace_ids: string[];
  max_results?: number;
  manufacturer_id?: string;
  device_model_id?: string;
  device_id?: string;
  withPosthogTracking?: boolean;
}

export type CaseDetailCorrected = Override<
  CaseDetail,
  {
    id: string;
    created_at: string;
    updated_at: string;
    public_id: string;
    serial_id_prefix: string;
    serial_id: number;
    status: CaseStatus;
    priority: number;
    due_at: string;
    reported_at: string;
    assessed_at: string;
    started_at: string;
    deployment_id: string;
    workspace_id: string;
    name: string;
    from_public_portal: boolean;
    device: DeviceDetailCorrected | null;
    case_tags: CaseTag[];
    cases_to_maintenances: Pick<CaseToMaintenance, "maintenance_id">[];
    cases_to_device_data_triggers: Pick<CaseToDeviceDatumTrigger, "device_data_trigger_id">[];
  }
>;

export enum CaseCustomFilter {
  Unassigned = "unassigned",
  Due = "due",
}
